export default __webpack_public_path__ + "static/media/2.db3918c9.png";